// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__12aLX","productName":"Table_productName__24TLu"};